import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="2026 Aegis Team"
      links={[
        {
          title: 'Aegis MDM',
          href: 'https://aegismdm.github.io',
          key: 'mobfoot',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
